import React from "react";
import Link, { ILink } from "../Link/Link";
import MediaBuilder, {
  IMediaBuilderProps,
} from "../../Utility/MediaBuilder/MediaBuilder";

export interface ICategory<LinkType> extends ILink<LinkType> {
  /** Id of category */
  id: string;
  /**
   * Category text naming
   */
  itemName?: string;
  /**
   * Category Image
   */
  itemMediaData?: IMediaBuilderProps;
  /**
   *  Category description
   */
  itemDescription?: string;
}

function Category<LinkType = HTMLLinkElement>({
  itemName,
  itemMediaData,
  itemDescription,
  linkParams,
}: ICategory<LinkType>): JSX.Element {
  return (
    <Link<LinkType>
      classes={{ root: "banner-card" }}
      data-testid="Category"
      {...(linkParams || {})}
    >
      <div className="banner-card--inner">
        <MediaBuilder
          classes={{ root: "banner-card__img" }}
          {...itemMediaData}
        />
        <div className="banner-card__text">
          <div className="banner-card__desc">{itemName}</div>
          <span className="banner-card__icon">{itemDescription}</span>
        </div>
      </div>
    </Link>
  );
}

export default Category;
